// import { useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const useBackButtonBlocker = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const unlisten = () => {
//       const isLoggedIn = !!sessionStorage.getItem('managerId');
//       // If not logged in and not already on login, force to login
//       if (!isLoggedIn && location.pathname !== '/') {
//         navigate('/', { replace: true });
//       }

//       if (!isLoggedIn) {
//         window.history.pushState(null, '', window.location.href);
//         const handlePopState = () => {
//           navigate('/', { replace: true });
//         };
//         window.addEventListener('popstate', handlePopState);

//         return () => {
//           window.removeEventListener('popstate', handlePopState);
//         };
//       }
//     };

//     unlisten();
//   }, [location, navigate]);
// };

// export default useBackButtonBlocker;



import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useBackButtonBlocker = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = !!sessionStorage.getItem('managerId');

    if (!isLoggedIn) {
      // Force to login if on any page except "/"
      if (location.pathname !== '/') {
        navigate('/', { replace: true });
      }

      // Prevent going back when not logged in
      window.history.pushState(null, '', window.location.href);

      const handlePopState = () => {
        navigate('/', { replace: true });
      };

      window.addEventListener('popstate', handlePopState);

      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }

    // If logged in → do not block
  }, [location, navigate]);
};

export default useBackButtonBlocker;
